import { render, staticRenderFns } from "./statDialy.vue?vue&type=template&id=4bd2c6ca&"
import script from "./statDialy.vue?vue&type=script&lang=js&"
export * from "./statDialy.vue?vue&type=script&lang=js&"
import style0 from "./statDialy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports